











import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { AuthStoreHelper, CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper } from '../../core/mixins';
import { FilterDateEvent } from '../../core/utils/types';
import { getDateFromDateFormatApi } from '../../core/utils';
import { TypeFilterDate } from '../../core/models/type-filter-date';
import Axios from 'axios';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import { PageTitle, PageCards } from '../../core/components';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import { AuthEvent } from '../../../store';

@Component({
    components: {
        PageTitle,
        PageCards
    }
})
export default class NormasPage extends Mixins(
    CompanyStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper,
    AuthStoreHelper
) {
    loaded: boolean = false;

    unsubscribe: () => void;

    created() {
        this.unsubscribe = this.$store.subscribe((mutation, stateList) => {
            if (mutation.type !== AuthEvent.SET_PRIVILEGES) return;
            this.checkPermissions();
        });
    }

    checkPermissions() {
        if (!this.shouldCreateAndReadNorms) {
            this.$router.push(NAME_ROUTES.HOME.path);
        }
    }

    destroyed() {
        this.unsubscribe();
    }

    cards: any = [
        {
            name: 'Listado de archivos database',
            icon: 'mdi-file-document',
            description: 'Agregar, eliminar y modificar archivos database',
            url: NAME_ROUTES.NORMAS_LIST_DATABASE.path,
            condition: () => this.shouldCreateOrDelete
        },
        {
            name: 'Listado de ECUs',
            icon: 'mdi-file-document',
            description: 'Agregar, eliminar y modificar ECUs',
            url: NAME_ROUTES.NORMAS_LIST_ECUS.path,
            condition: () => this.shouldCreateOrDelete
        },
        {
            name: 'Listado de Frames',
            icon: 'mdi-file-document',
            description: 'Agregar, eliminar y modificar Frames',
            url: NAME_ROUTES.NORMAS_LIST_FRAMES.path,
            condition: () => this.shouldCreateOrDelete
        },
        {
            name: 'Listado de DTCs',
            icon: 'mdi-file-document',
            description: 'Agregar, eliminar y modificar DTCs',
            url: NAME_ROUTES.NORMAS_LIST_DTC.path,
            condition: () => this.shouldCreateOrDelete
        },
        {
            name: 'Listado de variable clasification',
            icon: 'mdi-file-document',
            description: 'Agregar, eliminar y modificar variables classification',
            url: NAME_ROUTES.NORMAS_LIST_VARIABLE_CLASIFICATION.path,
            condition: () => this.isSmartWay() || this.shouldReadVariableClassification
        },
        {
            name: 'Listado de variable report',
            icon: 'mdi-file-document',
            description: 'Agregar, eliminar y modificar variables report',
            url: NAME_ROUTES.NORMAS_LIST_VARIABLE_REPORT.path,
            condition: () => this.isSmartWay() || this.shouldReadVariableClassification
        },
        {
            name: 'Listado de parámetros de frames',
            icon: 'mdi-file-document',
            description: 'Visualizar y modificar parámetros de frames',
            url: NAME_ROUTES.NORMAS_LIST_VARIABLE_GENERAL.path,
            condition: () => this.isSmartWay() || this.shouldReadVariableClassification
        }
    ];

    isSmartWay() {
        return this.$_userIsSmartway;
    }

    cardShouldBeAvailable(card) {
        if (!card.condition) return true;
        return card.condition();
    }

    get availableCards() {
        if (!this.loaded) return [];
        return this.cards.filter(card => this.cardShouldBeAvailable(card));
    }

    mounted() {
        this.loaded = true;
    }

    get shouldCreateAndReadNorms(): boolean {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.NORMS, PRIVILEGE_TYPES.READ) || this.$_userIsSmartway;
    }

    get shouldCreateOrDelete(): boolean {
        return (
            this.$_checkPrivileges(PRIVILEGE_KEYS.NORMS, PRIVILEGE_TYPES.EDIT_AND_DELETE) ||
            this.$_checkPrivileges(PRIVILEGE_KEYS.NORMS, PRIVILEGE_TYPES.CREATE)
        );
    }

    get shouldReadVariableClassification(): boolean {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.NORMS, PRIVILEGE_TYPES.READ);
    }
}
